import {
  getFindVenueOverviewVersionQueryKey,
  useUpdateVenueOverviewVersion,
} from '@api';
import { useInvalidateQuery, useNotification } from '@common';
import { AxiosError } from 'axios';
import { VenueMerchFormDataType } from '../useVenueMerchFormSchema';

const TRANS_PATH = 'NOTIFICATIONS.UPDATE_VENUE_MERCH';

type UseUpdateVenueMerchReturnType = {
  updateVenueMerch: (data: VenueMerchFormDataType) => Promise<void>;
};

type UseUpdateVenueMerchPropsType = {
  venueId: string;
  overviewVersion: string;
  onClose: () => void;
};

export const useUpdateVenueMerch = ({
  venueId,
  overviewVersion,
  onClose,
}: UseUpdateVenueMerchPropsType): UseUpdateVenueMerchReturnType => {
  const { mutateAsync } = useUpdateVenueOverviewVersion();
  const { showSuccess, showError } = useNotification();

  const { invalidateQuery } = useInvalidateQuery(
    getFindVenueOverviewVersionQueryKey(venueId, overviewVersion)
  );

  const onSuccess = (): void => {
    showSuccess({
      title: `${TRANS_PATH}.SUCCESS.TITLE`,
      message: `${TRANS_PATH}.SUCCESS.MESSAGE`,
    });
    invalidateQuery();
    onClose();
  };

  const onError = (error: AxiosError): void => {
    showError({
      title: `${TRANS_PATH}.ERROR.TITLE`,
      message: `${TRANS_PATH}.ERROR.MESSAGE`,
      error,
    });
  };

  const updateVenueMerch = async (
    data: VenueMerchFormDataType
  ): Promise<void> => {
    await mutateAsync(
      {
        venueId,
        overviewVersion,
        data: {
          merch: {
            rate: data.rate,
            companyContact: data.contact,
            notes: data.notes,
          },
        },
      },
      {
        onSuccess,
        onError,
      }
    );
  };

  return { updateVenueMerch };
};
